import React, { useState, useEffect } from 'react';
import "./Results.css";
import VideoCard from "./VideoCard";
import axios from "./axios";
// import requests from "./requests";
import FlipMove from "react-flip-move";

function Results({ selectedOption }) {
    const [movies, setMovies] = useState([]);
    // const [genres, setGenres] = useState([]);

    // This useeffect depends on a paramter from putside this component has to be passed as dependency
    useEffect(() => {
        async function fetchData() {
            const request = await axios.get(selectedOption);

            // console.log(request);
            // console.table(request);
            setMovies(request.data.results);
            return request;
        }
        fetchData();
    }, [selectedOption])



    // useEffect(() => {
    //     async function fetchGenres() {
    //         const request2 = await axios.get(requests.fetchGenre);

    //         console.log(request2);
    //         // console.table(request);
    //         setGenres(request2.data.genres.name);
    //         return request2;
    //     }
    //     fetchGenres();
    // }, [selectedOption])





    return (
        <div className="results">
            <FlipMove>

                {movies.map((movie) => (
                    <VideoCard key={movie.id} movie={movie} />
                ))}

                {/* {genres.map((genre) => (
                    <VideoCard movie={genre} />
                ))} */}
            </FlipMove>


        </div>
    )
}

export default Results
